import { useFeatureFlag } from '@fs/zion-flags'
import { useGroupsContext } from '@fs/zion-tree-groups'

export default function useGroupsFlags(flagName = 'memories_shared_familyGroups') {
  const { isOn: familyGroupsIsOn } = useGroupsContext()
  const flagIsOn = useFeatureFlag(flagName).isOn
  return Boolean(familyGroupsIsOn) || flagIsOn
}
